import CreateInvestmentError from './CreateInvestmentError';
class CouponIsDisabled extends CreateInvestmentError {
    constructor(options) {
        super('Coupon was disabled', options);
    }
}
export default CouponIsDisabled;
